<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fmtitlea">
<a id="page_i">Praise for</a></h1><a id="page_i">
<h1 class="fmtitle1a"><em class="italic">Lord Valentine’s Castle</em></h1>
<p class="noindent">“[A] heady blend of rigorous SF world building and the poetic sensibility of fantasy fiction.”</p>
<p class="right">—Sci Fi Weekly</p>
<p class="noindent">“A grand, picaresque tale … by one of the great storytellers of the century. <em class="italic">Lord Valentine’s Castle</em> has everything.”</p>
<p class="right">—Roger Zelazny</p>
<p class="noindent">“Silverberg has created a big planet, chockablock with life and potential.”</p>
<p class="right">—<em class="italic">The Washington Post</em></p>
<p class="noindent">“This absorbing book is … successful in creating a wildly imaginative universe. It is also better written than most in this genre and deserves to be one of the year’s hits, sci-fi or otherwise.”</p>
<p class="right">—<em class="italic">People</em></p>
<p class="noindent">“In this richly imagined setting, Valentine not only learns about his world but about himself and his proper place in it…. Robert Silverberg’s writing and imagination soar with nary a false step. It is truly an extraordinary tale, well told.”</p>
<p class="right">—SFFaudio</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Praise.vue?309fe69c